import React, { useState } from 'react';
import { Search, HelpCircle, User } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = ({ searchQuery, handleSearchChange, isAuthenticated, navigate }) => {
    const popularSearches = [
        { label: 'Pay Rentals', path: '/service/b5b2fc14-d85b-4a26-92af-8bf445cbc7d2' },
        { label: 'Apply for Government Property', path: '/service/e2e26caf-63f1-4b2d-a89e-fc56084bf395' },
        { label: 'Property Valuation Consultancy', path: '/service/130a90fc-06e3-4ee6-ab19-54173ce8d726' },
        { label: 'Landscaping Services', path: '/service/4c22e695-60a0-4f56-91bc-83c1fd57a057' },
    ];

    return (
        <div style={styles.heroContainer}>
            <div style={styles.heroActions}>
                <button style={styles.actionButton} onClick={() => navigate('/help')}>
                    <HelpCircle size={16} /> Help
                </button>
                <button style={styles.actionButton} onClick={() => navigate(isAuthenticated ? '/my-workplace' : '/login')}>
                    <User size={16} /> My Workplace
                </button>
            </div>
            <div style={styles.heroOverlay}></div>
            <div style={styles.container}>
                <div style={styles.heroContent}>
                    <h1 style={styles.h1}>Digital Government at Your Service</h1>
                    <p style={styles.p}>One-Stop Shop for All Public Services in Zambia</p>
                    <div style={styles.searchBarContainer}>
                        <Search style={styles.searchIcon} />
                        <input
                            type="text"
                            placeholder="Search by Service Name, Category, etc."
                            style={styles.searchInput}
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <button style={styles.searchButton}>Search</button>
                    </div>
                    <div>
                        <p style={styles.popularSearchesP}>Most popular:</p>
                        <div style={styles.popularSearchesContainer}>
                            {/* 2. Use the new helper component here */}
                            {popularSearches.map((item) => (
                                <PopularLink key={item.label} to={item.path}>
                                    {item.label}
                                </PopularLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div style={styles.waveContainer}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" style={{ width: '100%' }}>
                    <path fill="#ffffff" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
                </svg>
            </div>
        </div>
    );
};

// 3. New Helper Component to handle Hover Logic
const PopularLink = ({ to, children }) => {
    const [isHovered, setIsHovered] = useState(false);

    const linkStyle = {
        ...styles.popularSearchBase,
        // On hover, make background whiter (more opaque) and border stronger
        backgroundColor: isHovered ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.2)',
        borderColor: isHovered ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.3)',
        transform: isHovered ? 'translateY(-1px)' : 'none', // Slight lift effect
    };

    return (
        <Link
            to={to}
            style={linkStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </Link>
    );
};

const styles = {
    heroContainer: {
        position: 'relative',
        background: 'linear-gradient(to bottom right, #146633, #198b44, #22a555)',
        color: 'white',
        overflow: 'hidden',
    },
    heroActions: {
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        display: 'flex',
        gap: '1rem',
        zIndex: 20,
    },
    actionButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        padding: '0.5rem 1rem',
        borderRadius: '9999px',
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    heroOverlay: {
        position: 'absolute',
        inset: 0,
        opacity: 0.1,
        backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 255, 255, 0.05) 10px, rgba(255, 255, 255, 0.05) 20px)',
    },
    container: {
        maxWidth: '1150px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '5rem 1rem',
        position: 'relative',
        zIndex: 10,
    },
    heroContent: {
        maxWidth: '48rem',
    },
    h1: {
        marginBottom: '1rem',
        fontSize: '2.25rem',
        fontWeight: 'bold',
    },
    p: {
        fontSize: '1.25rem',
        marginBottom: '2rem',
        color: '#f0fdf4',
    },
    searchBarContainer: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '1.5rem',
    },
    searchIcon: {
        marginLeft: '0.75rem',
        height: '1.25rem',
        width: '1.25rem',
        color: '#9ca3af',
    },
    searchInput: {
        flex: '1 1 0%',
        border: '0',
        outline: 'none',
        fontSize: '1rem',
        backgroundColor: 'transparent',
    },
    searchButton: {
        padding: '0.75rem 1.5rem',
        backgroundColor: '#198b44',
        color: 'white',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
    },
    popularSearchesP: {
        fontSize: '0.875rem',
        marginBottom: '0.75rem',
        color: '#f0fdf4',
    },
    popularSearchesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.5rem',
    },
    // 4. Renamed to 'Base' to indicate it's the foundation for the PopularLink component
    popularSearchBase: {
        padding: '0.5rem 1rem',
        borderRadius: '9999px',
        color: 'white',
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: '0.9rem',
        border: '1px solid transparent', // ensuring border width is constant
        transition: 'all 0.2s ease', // Smooth transition for hover effect
    },
    waveContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
    },
};

export default Hero;